/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Deleted_DescriptionInputs */



/**
* | output |
* | --- |
* | "Event exists in Group A but not in Group B" |
*
* @param {Compare_Event_Groups_Deleted_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_deleted_description = /** @type {((inputs?: Compare_Event_Groups_Deleted_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Deleted_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'événement existe dans le groupe A mais pas dans le groupe B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Ereignis existiert in Gruppe A, aber nicht in Gruppe B.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'evento esiste nel Gruppo A ma non nel Gruppo B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Событие существует в группе А, но отсутствует в группе В.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El evento existe en el Grupo A pero no en el Grupo B")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("该事件存在于A组中，但不存在于B组中。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントはグループ A には存在するがグループ B には存在しない")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह घटना समूह A में मौजूद है लेकिन समूह B में नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O evento existe no Grupo A, mas não no Grupo B.")
	return /** @type {LocalizedString} */ ("Event exists in Group A but not in Group B")
});